import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Close';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from '@mui/x-data-grid';
import {
  randomArrayItem,
} from '@mui/x-data-grid-generator';

const roles = ['Market', 'Finance', 'Development'];
const randomRole = () => {
  return randomArrayItem(roles);
};

const initialRows = [
  {
    id: 1,
    nombreProducto: 'Coca Cola',
    cantidad: 25,
    costo: 2.50,
    total: 25 * 2.5,
    ubicacion: 'Almacen',
    vencimiento: new Date('2024/06/18'),
  },
  {
    id: 2,
    nombreProducto: 'Leche Pil',
    cantidad: 36,
    costo: 7.30,
    total: 36 * 7.30,
    ubicacion: 'Tienda',
    vencimiento: new Date('2024/09/11'),
  },
  {
    id: 3,
    nombreProducto: 'Jamon Stege',
    cantidad: 19,
    costo: 11.00,
    total: 19 * 11.00,
    ubicacion: 'Almacen',
    vencimiento: new Date('2025/02/23'),
  },
  {
    id: 4,
    nombreProducto: 'Dulce de leche',
    cantidad: 28,
    costo: 12.50,
    total: 28 * 12.50,
    ubicacion: 'Almacen',
    vencimiento: new Date('2024/07/09'),
  },
  {
    id: 5,
    nombreProducto: 'Arroz Chino',
    cantidad: 23,
    costo: 9.10,
    total: 23 * 9.10,
    ubicacion: 'Tienda',
    vencimiento: new Date('2024/02/10'),
  },
];

function EditToolbar(props) {
  const { setRows, setRowModesModel } = props;

  const handleClick = () => {
    const id = 7;
    setRows((oldRows) => [...oldRows, { id, nombreProducto: 'Singani', cantidad: '2', costo: '25', total: '50', ubicacion: 'Tienda', vencimiento: new Date('2024/02/10'), isNew: true }]);
    //setRowModesModel((oldModel) => ({
    //  ...oldModel,
    //  [id]: { mode: GridRowModes.Edit, fieldToFocus: 'nombreProducto' },
    //}));
  };

  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        Add record
      </Button>
    </GridToolbarContainer>
  );
}




export default function AlmacenTabla() {
  const [rows, setRows] = React.useState(initialRows);
  const [rowModesModel, setRowModesModel] = React.useState({});

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const total = newRow.cantidad * newRow.costo;
    const updatedRow = { ...newRow, total: total, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const columns = [
    { field: 'nombreProducto', headerName: 'Producto', width: 160, editable: true },
    {
      field: 'cantidad',
      headerName: 'Cantidad',
      type: 'number',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      editable: true,
    },
    {
        field: 'costo',
        headerName: 'Costo',
        type: 'number',
        width: 100,
        align: 'center',
        headerAlign: 'center',
        editable: true,
      },
      {
        field: 'total',
        headerName: 'Total',
        type: 'number',
        width: 100,
        align: 'center',
        headerAlign: 'center',
        editable: false,
      },
    {
      field: 'vencimiento',
      headerName: 'Vencimiento',
      type: 'date',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      editable: true,
    },
    {
      field: 'ubicacion',
      headerName: 'Ubicación',
      width: 120,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['Almacen', 'Tienda'],
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<CheckBoxIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <Box
      sx={{
        height: 500,
        width: '100%',
        '& .actions': {
          color: 'text.secondary',
        },
        '& .textPrimary': {
          color: 'text.primary',
        },
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        slots={{ toolbar: EditToolbar,}}
        slotProps={{
          toolbar: { setRows, setRowModesModel },
        }}
        options={{ pagination: false }}
      />
    </Box>
  );
}